
export const formatDate = (dateString, formatType = "dd-mm-yyyy") => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const options = {
    "dd-mm-yyyy": { day: "2-digit", month: "2-digit", year: "numeric" },
    "mm-dd-yyyy": { month: "2-digit", day: "2-digit", year: "numeric" },
    "yyyy-mm-dd": { year: "numeric", month: "2-digit", day: "2-digit" },
    yyyy: { year: "numeric" },

    "full-date": {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },

    "short-date": { year: "numeric", month: "short", day: "numeric" },

    "time-only": {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    },

    "date-time": {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    },

    // Existing format (date only)
    "day-shortMonth-year": { day: "2-digit", month: "short", year: "numeric" },

    // ✅ New format: date + time
    "day-shortMonth-year-time": {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    },

    "dd-mm-yyyy-time": {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    },
  };

  // Use en-GB to force DD/MM/YYYY format instead of US MM/DD/YYYY
  // Always render in Indian Standard Time regardless of viewer's local timezone
  return new Intl.DateTimeFormat("en-GB", {
    ...(options[formatType] || options["dd-mm-yyyy"]),
    timeZone: "Asia/Kolkata",
  }).format(date);
};


export const toCamelCase = (str) => {
  if (typeof str !== "string" || str === "") return str;
  if (str.toLowerCase() === "lakh") return "L";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Centrally compute SSL status from remaining days
 * @param {number|null} daysRemaining 
 * @returns {'valid' | 'expiring' | 'critical' | 'expired' | 'unknown'}
 */
export const getSSLStatus = (daysRemaining) => {
  if (daysRemaining === null || daysRemaining === undefined) return 'unknown';
  if (daysRemaining <= 0) return 'expired';
  if (daysRemaining <= 7) return 'critical';
  if (daysRemaining <= 30) return 'expiring';
  return 'valid';
};

/**
 * Capitalize first letter of a string
 */
export const capitalize = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};